// expenditure
const ExpenditureIndex = () =>
  import("./expenses/index.vue");

// payments
const PaymentsIndex = () =>
  import("./payments/index.vue");
const SalesPaymentsReport = () =>
  import("./payments/sales.vue");
const PurchasePaymentsReport = () =>
  import("./payments/purchases.vue");
const OwnerPaymentsReport = () =>
  import("./payments/owner-payments.vue");

// pnl
const PnlIndex = () => import("./pnl/index.vue");
const PnlSLIndex = () =>
  import("./pnl/transactions.vue");

// stock transfer
const StockTransferIndex = () =>
  import("./stock-transfers/index.vue");
const TransferIndex = () =>
  import("./stock-transfers/stock.vue");
const TransferDeliveries = () =>
  import("./stock-transfers/deliveries.vue");
const ViewTransfer = () =>
  import("./stock-transfers/view.vue");

// damaged
const DamagedIndex = () =>
  import("./damages/index.vue");
const DamagedProducts = () =>
  import("./damages/products.vue");

// stock value
const StockValueIndex = () =>
  import("./stockvalue/index.vue");

// combined stock value
const CombinedStockValueIndex = () =>
  import("./combined-stock-value/index.vue");

// available stock
const AvailableValueIndex = () =>
  import("./available-stock/index.vue");
const AvailableSLIndex = () =>
  import("./available-stock/stock.vue");

// stock deficits
const StockDeficits = () =>
  import("./general/deficits.vue");
const CombinedStock = () =>
  import("./general/combined-stock.vue");

// low stock report
const LowStockIndex = () =>
  import("./low-stock/index.vue");
const LowStockReport = () =>
  import("./low-stock/stock.vue");

// low stock report
const StockAuditIndex = () =>
  import("./stock-audit/index.vue");
const StockAuditReport = () =>
  import("./stock-audit/stock.vue");

// stock adjustment
const StockAdjIndex = () =>
  import("./stock-adjustment/index.vue");

// lists
const BpList = () =>
  import("./lists/buying-price.vue");

// statements
const CustomerStatement = () =>
  import("./statements/customer.vue");
const CustomerStatementIndex = () =>
  import("./statements/customers-list.vue");
const SupplierStatement = () =>
  import("./statements/supplier.vue");
const SupplierStatementIndex = () =>
  import("./statements/suppliers-list.vue");

const OwnerCheckStock = () =>
  import("./owner-reports/owner-check-stock.vue");
const OwnerCombinedStock = () =>
  import(
    "./owner-reports/owner-combined-stock.vue"
  );
const OwnerSoldProducts = () =>
  import(
    "./owner-reports/owner-sold-products.vue"
  );

const StockAnalysisIndex = () =>
  import("./stock-analysis/index.vue");
const StockMovementTotals = () =>
  import("./stock-analysis/movement-totals.vue");

export default [
  {
    path: "/payments-report",
    component: OwnerPaymentsReport,
  },
  {
    path: "/stock/movement/analysis",
    component: StockAnalysisIndex,
  },
  {
    path: "/stock/movement/totals",
    component: StockMovementTotals,
  },
  {
    path: "/owner-check-stock",
    component: OwnerCheckStock,
  },
  {
    path: "/owner-combined-stock",
    component: OwnerCombinedStock,
  },
  {
    path: "/owner-sold-products",
    component: OwnerSoldProducts,
  },
  {
    path: "/list/report/bp",
    component: BpList,
  },
  {
    path: "/statement/customer",
    component: CustomerStatementIndex,
  },
  {
    path: "/statement/customer/:id",
    component: CustomerStatement,
  },
  {
    path: "/statement/supplier",
    component: SupplierStatementIndex,
  },
  {
    path: "/statement/supplier/:id",
    component: SupplierStatement,
  },
  {
    path: "/stock/report/low",
    component: LowStockIndex,
    children: [
      {
        path: "",
        component: LowStockReport,
      },
    ],
  },
  {
    path: "/stock/report/audit",
    component: StockAuditIndex,
    children: [
      {
        path: "",
        component: StockAuditReport,
      },
    ],
  },
  {
    path: "/stock/report/transfers",
    component: StockTransferIndex,
    children: [
      {
        path: "",
        component: TransferIndex,
      },
    ],
  },
  {
    path: "/stock/transfer/deliveries",
    component: TransferDeliveries,
  },
  {
    path: "/stock/transfer/view/:id",
    component: ViewTransfer,
  },
  {
    path: "/damaged/products",
    component: DamagedIndex,
    children: [
      {
        path: "",
        component: DamagedProducts,
      },
    ],
  },
  {
    path: "/pnl/report",
    component: PnlIndex,
    children: [
      {
        path: "",
        component: PnlSLIndex,
      },
    ],
  },
  {
    path: "/stock/report/valuation",
    component: StockValueIndex,
  },
  {
    path: "/combined-stock-value",
    component: CombinedStockValueIndex,
  },
  {
    path: "/stock/report/available",
    component: AvailableValueIndex,
    children: [
      {
        path: "",
        component: AvailableSLIndex,
      },
    ],
  },
  {
    path: "/expenditure-summary",
    component: ExpenditureIndex,
  },
  {
    path: "/payments-summary",
    component: PaymentsIndex,
  },
  {
    path: "/sale-payments-report",
    component: SalesPaymentsReport,
  },
  {
    path: "/purchase-payments-report",
    component: PurchasePaymentsReport,
  },
  {
    path: "/stock-deficits",
    component: StockDeficits,
  },
  {
    path: "/stock/report/negatives",
    component: StockDeficits,
  },
  {
    path: "/combined-stock",
    component: CombinedStock,
  },
  {
    path: "/stock/report/combined",
    component: CombinedStock,
  },
  {
    path: "/stock-adjustment-report",
    component: StockAdjIndex,
  },
];
